export default __webpack_public_path__ + "static/alpinamed-referenz-banner-55cf6ccdeb607135bc0c4b87bd3d27d9.webp";